import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../../../api";

// Component for managing system settings such as timezone, date format, and time format
const SystemSettings = () => {
  // State variables for system settings
  const [timezone, setTimezone] = useState('');
  const [dateFormat, setDateFormat] = useState('');
  const [timeFormat, setTimeFormat] = useState('');
  // State variable for loading state
  const [loading, setLoading] = useState(false);  

  // Fetch system settings on component mount
  useEffect(() => {
    // Function to fetch system settings from the server
    const fetchSettings = async () => {
      try {
        const res = await axiosInstance.get('/ems/get-system-setting');
        if (res.data?.status === "success" && res.data.data.length > 0) {
          const data = res.data.data[0];
          setTimezone(data.timezone || '');
          setDateFormat(data.date_format || '');
          setTimeFormat(data.time_format || '');
        }
      } catch (err) {
        console.error("Error fetching system settings", err);
      }
    };
    fetchSettings();
  }, []);

  // Function to save system settings
  const saveSettings = async () => {
    try {
      const payload = {
        time_zone: timezone,
        date_format: dateFormat,
        time_format: timeFormat,
      };
      const res = await axiosInstance.post('/ems/store-system-setting', payload);
      if (res.data?.status === "success") {
        alert("System settings saved successfully");
      }
    } catch (err) {
      console.error("Error saving system settings", err);
    }
  };

  // Handle save button click
  const handleClick = async () => {
    setLoading(true);
    try {
      await saveSettings();
    } finally {
      setLoading(false);
    }
  };

  // Render the system settings interface
  return (
    <div className="tab-pane active" id="system-settings" role="tabpanel">
      {/* Time Zone Settings Section */}
      <div className="data-panel mt-5">
        <h6 className="px-2 mb-2">Time Zone Settings</h6>
        <form>
          <div className="form-group col-lg-4 p-2">
            <select 
              className="form-control form-select"
              value={timezone}
              onChange={(e) => setTimezone(e.target.value)}
            >
              <option value="Asia/Kolkata">India Standard Time (IST) – UTC +5:30</option>
              <option value="America/New_York">Eastern Standard Time (EST) – UTC -5:00</option>
              <option value="Asia/Dubai">Gulf Standard Time (GST) – UTC +4:00</option>
              <option value="Australia/Sydney">Australian Eastern Time (AET) – UTC +10:00</option>
              <option value="Europe/London">Greenwich Mean Time (GMT) – UTC +0:00</option>
            </select>
          </div>
        </form>
      </div>

      {/* Date Format Settings Section */}
      <div className="data-panel mt-5">
        <h6 className="px-2 mb-2">Date Format</h6>
        <form>
          <div className="form-group col-lg-12 p-2">
            <div className="form-check mb-3">
              <input 
                className="form-check-input primary check-outline outline-primary" 
                type="radio" 
                name="date-format" 
                id="date-ddmmyyyy" 
                value="DD/MM/YYYY" 
                checked={dateFormat === "DD/MM/YYYY"}
                onChange={(e) => setDateFormat(e.target.value)}
              />
              <label className="form-check-label" htmlFor="date-ddmmyyyy">DD/MM/YYYY</label>
            </div>
            <div className="form-check mb-3">
              <input 
                className="form-check-input primary check-outline outline-primary" 
                type="radio" 
                name="date-format" 
                id="date-mmddyyyy" 
                value="MM/DD/YYYY"
                checked={dateFormat === "MM/DD/YYYY"}
                onChange={(e) => setDateFormat(e.target.value)}
              />
              <label className="form-check-label" htmlFor="date-mmddyyyy">MM/DD/YYYY</label>
            </div>
            <div className="form-check mb-3">
              <input 
                className="form-check-input primary check-outline outline-primary" 
                type="radio" 
                name="date-format" 
                id="date-yyyy-mm-dd" 
                value="YYYY-MM-DD"
                checked={dateFormat === "YYYY-MM-DD"}
                onChange={(e) => setDateFormat(e.target.value)}
              />
              <label className="form-check-label" htmlFor="date-yyyy-mm-dd">YYYY/MM/DD</label>
            </div>
          </div>
        </form>
      </div>

      {/* Time Format Settings Section */}
      <div className="data-panel mt-5">
        <h6 className="px-2 mb-2">Time Format</h6>
        <form>
          <div className="form-group col-lg-12 p-2">
            <div className="form-check mb-3">
              <input 
                className="form-check-input primary check-outline outline-primary" 
                type="radio" 
                name="time-format" 
                id="time-12" 
                value="12" 
                checked={timeFormat === "12"}
                onChange={(e) => setTimeFormat(e.target.value)}
              />
              <label className="form-check-label" htmlFor="time-12">12-hour</label>
            </div>
            <div className="form-check mb-3">
              <input 
                className="form-check-input primary check-outline outline-primary" 
                type="radio" 
                name="time-format" 
                id="time-24" 
                value="24"
                checked={timeFormat === "24"}
                onChange={(e) => setTimeFormat(e.target.value)}
              />
              <label className="form-check-label" htmlFor="time-24">24-hour</label>
            </div>
          </div>
        </form>
      </div>

      {/* Save Settings Button */}
      <button
        type="button"
        className="btn mb-1 waves-effect waves-light btn-outline-primary mt-3"
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Saving...
          </>
        ) : (
          "Save Settings"
        )}
      </button>
    </div>
  );
};

// Export the component as default
export default SystemSettings;